import { MainLayout } from 'components/layout/mainLayout';
// import { Link } from 'react-router-dom';
import { MainVotes } from 'components/votes';
import {Contest, MainBlock, Nomination, Calendar, Sponsor} from 'blocks'
// import {useAuthState} from 'context';

export const Main = () => {
    // const { token } = useAuthState()

    return (
		<MainLayout>
            <MainBlock />
            <Contest />
            <Nomination />
            <Calendar />
            {/* <div className='container'>
                <div className='calendar__banner calendar__banner_danger'>
                    <div className='calendar__banner-text'>
                        <h3>Лучший дом. Лучший двор</h3>
                        <span>
						    Всероссийский Конкурс лучших практик управления многоквартирными домами
						</span>
                    </div>
                    <Link to={!token ? '/login' : '/voting'}>
                        <button className='main__btn button' type='button'>
                            Смотреть заявки
                        </button>
                    </Link>
                </div>
            </div> */}
            <MainVotes />
            <Sponsor />
		</MainLayout>
	);
};
